module.exports = __webpack_public_path__ + "static/media/temperature-hot.82509704.svg";